type Props = {
    isActive: boolean
    onClick: any
}

const BannerViewIcon = ({ isActive, onClick }: Props) => {
    const height = '23'
    const width = '23'

    return (
        <svg
            style={{ cursor: 'pointer' }}
            onClick={onClick}
            width={`${width}`}
            height={`${height}`}
            viewBox={`0 0 ${width} ${height}`}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            opacity="1"
        >
            <line
                y1="1.5"
                x2="22"
                y2="1.5"
                stroke={`${isActive ? '#8F8F8F' : '#E0E0E0'}`}
                strokeWidth="2.8"
            />
            <line
                y1="11.5"
                x2="22"
                y2="11.5"
                stroke={`${isActive ? '#8F8F8F' : '#E0E0E0'}`}
                strokeWidth="2.8"
            />
            <line
                y1="21.5"
                x2="22"
                y2="21.5"
                stroke={`${isActive ? '#8F8F8F' : '#E0E0E0'}`}
                strokeWidth="2.8"
            />
        </svg>
    )
}

export default BannerViewIcon
